import * as React from 'react';

import { UitkBadgeTheme, UitkBadge } from 'uitk-react-badge';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';

import { OfferBadgeType } from 'types/shared';

interface FlightBadgesProps {
  badges?: OfferBadgeType[];
}

export const FlightBadges = ({ badges }: FlightBadgesProps) => {
  const renderBadge = (badge: OfferBadgeType, badgeIndex: number) => {
    return (
      <UitkBadge
        key={`badgeKey-${badgeIndex}`}
        text={badge.text}
        theme={UitkBadgeTheme[badge.type]}
        preTextContent={
          badge.icon &&
          badge.icon.id && <UitkIcon className="uitk-badge-icon" name={badge.icon.id} size={UitkIconSize.EXTRA_SMALL} />
        }
      />
    );
  };

  return (
    <UitkLayoutFlex space="two" data-test-id="flights-badges">
      {badges.map((badgeInfo, badgeIndex) => renderBadge(badgeInfo, badgeIndex))}
    </UitkLayoutFlex>
  );
};
